/*
 * @Author: shiguang
 * @Date: 2023-07-18 19:22:16
 * @LastEditors: shiguang
 * @LastEditTime: 2023-08-14 18:30:30
 * @Description: vr
 */
import { createVNode, render } from 'vue'
import ConfirmDialog from './ConfirmDialog.vue'
const container = document.createElement('div')
container.setAttribute('class', 'confirm-dialog-container')
document.body.appendChild(container)

interface OnOKOptions{
  /** 关闭 modal */
  hideModal: () => void;
}
interface CDP {
  title: string
  text: string
  ok?: any
  cancel?: any
  htmlNode?: boolean
  width?: number
  okText?: string
  cancelText?: string
  closeOnClickModal?: boolean
  onOk?: (options: OnOKOptions) => void;
  onCancel?: (options: OnOKOptions) => void;
}
export default (props:CDP) => {
  const { onOk, onCancel } = props
  return new Promise((resolve, reject) => {
    const hideModal = () => render(null, container)
    // 点击确认按钮
    const ok = () => {
      // 销毁确认框
      onOk?.({ hideModal })
      render(null, container)
      resolve(true)
    }
    // 点击取消按钮
    const cancel = () => {
      // 销毁确认框
      onCancel?.({ hideModal })
      render(null, container)

      // reject(new Error())
    }
    // 把组件渲染到页面中
    const vnode = createVNode(ConfirmDialog, { ...props, ok, cancel })
    // 把虚拟节点渲染DOM中
    render(vnode, container)
  })
}
